import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Calculator = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Calculator" {...props}>
    <path d="M18 1C20.7614 1 23 3.23858 23 6V18C23 20.7614 20.7614 23 18 23H6C3.23858 23 1 20.7614 1 18V6C1 3.23858 3.23858 1 6 1H18ZM3 18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V8H3V18ZM7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15ZM12 15C13.1046 15 14 15.8954 14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15ZM17 10C18.1046 10 19 10.8954 19 12V17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17V12C15 10.8954 15.8954 10 17 10ZM7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM6 3C4.34315 3 3 4.34315 3 6H21C21 4.34315 19.6569 3 18 3H6Z" fill="#000" />
  </StyledIcon>
));

Calculator.displayName = 'Calculator';

export { Calculator };
